const Vr19 = () => {
 
    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-19/PNG%20n.1/3d%20%2019-1/publish%2019-1/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 19 Tour"
        ></iframe>
      </div>
    );
};

export default Vr19;
